import Vue from "vue";

export async function fetchGalleries({ commit }, ln_user) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/galleries?view_as=${ln_user}`
    });
    commit("galleries/setGalleries", data, { root: true });
  } catch (e) {
    commit("galleriesError", e.message);
  } finally {
  }
}
